export const ImageWithTitle = ({ image, title }) => {
    return (
        <div style={{display: 'block'}}>
            <div>
                {title}
            </div>
            <div>
                <img className="setting-label" src={image} alt={title} />
            </div>
        </div>
    )
}